import {AnimatePresence, motion} from 'framer-motion'
import {PropsWithChildren, useRef, useEffect} from 'react'
import {OPACITY_0, OPACITY_1} from 'src/common/constants'

type SubmenuProps = PropsWithChildren & {
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  isOpen: boolean
}

const desktopAnimation = {
  initial: OPACITY_0,
  animate: OPACITY_1,
  exit: OPACITY_0,
}

export const MobileSubmenu = ({children, handleMouseEnter, handleMouseLeave, isOpen}: SubmenuProps) => {
  const submenuRef = useRef<HTMLDivElement>(null)

  // Get submenu width on mobile
  useEffect(() => {
    const target = document.getElementById('nav-bar-container')
    const submenuEl = submenuRef.current

    if (target && submenuEl) {
      const updateWidth = () => {
        submenuEl.style.width = `${target.offsetWidth}px`
      }

      updateWidth()
      window.addEventListener('resize', updateWidth)

      return () => window.removeEventListener('resize', updateWidth)
    }

    return () => {}
  }, [])

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{opacity: 0, maxHeight: 0}}
          animate={{opacity: 0.95, maxHeight: '3000px'}}
          exit={{opacity: 0, maxHeight: 0}}
          transition={{duration: 0.5}}
        >
          <div className="w-full" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} ref={submenuRef}>
            <div
              {...desktopAnimation}
              className="flex w-full max-w-[1200px] gap-y-0 overflow-visible rounded-[4px] border-grey-135 font-normal outline outline-moss-white/[10%] max-lg:flex-col max-lg:py-4 lg:mx-[50%] lg:-translate-x-1/2 lg:overflow-y-scroll lg:bg-moss-white/[95%] lg:outline-[1px]"
            >
              {children}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
